'use client';

import { DropdownMenuTrigger } from '@radix-ui/react-dropdown-menu';
import { Table } from '@tanstack/react-table';

import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator
} from './dropdown-menu';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { createQueryString } from '#/lib/utils';
import { Icons } from '../icons';

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
  remote?: boolean;
}

export const COLUMN_VISIBLE_SHOW_KEY = 'cshow';
export const COLUMN_VISIBLE_HIDE_KEY = 'chide';

export function DataTableViewOptions<TData>({
  table,
  remote
}: DataTableViewOptionsProps<TData>) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="hidden h-8 lg:flex ml-2"
          >
            <Icons.settings2 className="mr-2 h-4 w-4" />
            컬럼
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-[150px] max-h-96 overflow-y-auto"
        >
          <DropdownMenuLabel>컬럼 보기/숨기기</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {table
            .getAllColumns()
            .filter(
              (column) =>
                typeof column.accessorFn !== 'undefined' && column.getCanHide()
            )
            .map((column) => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  className="capitalize"
                  checked={column.getIsVisible()}
                  onCheckedChange={(value) => {
                    column.toggleVisibility(!!value);
                    if (remote) {
                      const columnState = {
                        ...table.options.state.columnVisibility,
                        [column.id]: !!value
                      };
                      let params: any = {};
                      const keys = Object.keys(columnState);
                      const show = keys.filter((k) => columnState[k]).join('.');
                      const hide = keys
                        .filter((k) => !columnState[k])
                        .join('.');

                      if (show) {
                        params[COLUMN_VISIBLE_SHOW_KEY] = show;
                      }
                      if (hide) {
                        params[COLUMN_VISIBLE_HIDE_KEY] = hide;
                      }
                      router.push(
                        `${pathname}?${createQueryString(searchParams, params)}`
                      );
                    }
                  }}
                >
                  {column.columnDef.meta?.title ?? column.id}
                </DropdownMenuCheckboxItem>
              );
            })}
        </DropdownMenuContent>
      </DropdownMenu>
      <Button
        variant="outline"
        onClick={() => router.refresh()}
        className="hidden h-8 lg:flex ml-2"
      >
        <Icons.refresh className="mr-2 h-4 w-4" />
        갱신
      </Button>
    </>
  );
}
